export const ACCOUNT_DOCUMENT_TYPES = {
  ALERT_PROTOCOL: "alertProtocol",
  CLINIC_PROTOCOL: "clinicProtocol",
};

export const AVAILABILITY_FLAG = {
  [ACCOUNT_DOCUMENT_TYPES.ALERT_PROTOCOL]: "alert_protocol_available",
  [ACCOUNT_DOCUMENT_TYPES.CLINIC_PROTOCOL]: "clinic_protocol_available",
};
